module.exports = __webpack_public_path__ + "img/powerby-dark.acc122b8.svg";